import {Component, Input, OnInit} from '@angular/core';
import {V3Correction, V3CorrectionAnswerHolder, V3ExerciseSessionQuestion} from "../../../../cspa/model/v3/cspa";

@Component({
    selector: 'app-cor-result',
    templateUrl: './cor-result.component.html',
    styleUrls: ['./cor-result.component.scss'],
    standalone: false
})
export class CorResultComponent implements OnInit {
  @Input() questions: V3ExerciseSessionQuestion[] = []

  constructor() { }

  ngOnInit(): void {
  }

  getCorrectAnswer(q: V3ExerciseSessionQuestion) {
    const questionDef = q.questionDef as V3Correction
    return questionDef.answerDef.correct
  }

  getStudentAnswer(q: V3ExerciseSessionQuestion) {
    const answerHolder = q.questionDef?.answerDef?.answerHolder as V3CorrectionAnswerHolder | null
    return answerHolder?.response
  }

  isIncorrect(q: V3ExerciseSessionQuestion) {
    return !q.isCorrect
  }
}
